import { showToast } from "../utils/toast";
import { closeDatePicker } from "./date_picker";
import { closePopover } from "./popovers";
import { pipelineRoot } from "./request";

function parts(): { drawer: HTMLElement | null; backdrop: HTMLElement | null } {
  const root = pipelineRoot();
  return {
    drawer: root?.querySelector<HTMLElement>("[data-pl-drawer]") || null,
    backdrop: root?.querySelector<HTMLElement>("[data-pl-drawer-backdrop]") || null,
  };
}

export function closeDrawer(): void {
  const { drawer, backdrop } = parts();
  if (!drawer?.classList.contains("open")) return;
  closePopover();
  closeDatePicker();
  drawer.classList.remove("open");
  drawer.setAttribute("aria-hidden", "true");
  backdrop?.classList.remove("open");
}

export async function openDrawer(card: HTMLElement): Promise<void> {
  const root = pipelineRoot();
  const { drawer, backdrop } = parts();
  if (!root || !drawer) return;
  const url = new URL((root.dataset.entryUrl || "/pipeline_entries/__ID__").replace("__ID__", encodeURIComponent(card.dataset.plCard!)), window.location.origin);
  url.searchParams.set("context", root.dataset.context || "bot");
  try {
    const response = await fetch(url.toString(), { headers: { Accept: "text/html" }, credentials: "same-origin" });
    if (!response.ok) throw new Error(String(response.status));
    drawer.innerHTML = await response.text();
  } catch {
    showToast("This candidate is no longer in the pipeline.", "error", 3000);
    return;
  }
  drawer.classList.add("open");
  drawer.setAttribute("aria-hidden", "false");
  backdrop?.classList.add("open");
  drawer.querySelector<HTMLElement>("[data-pl-drawer-close]")?.focus();
}

let bound = false;

export function initDrawer(): void {
  if (bound) return;
  bound = true;
  document.addEventListener("click", (event) => {
    const target = event.target as HTMLElement;
    if (target.closest("[data-pl-drawer-close]") || target.matches("[data-pl-drawer-backdrop]")) closeDrawer();
  });
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !document.querySelector(".pl-pop, .pl-cal") && !(event.target as HTMLElement).closest?.("[data-pl-next-action]")) {
      closeDrawer();
    }
  });
  document.addEventListener("turbo:before-cache", () => closeDrawer());
}
